import React from "react";

function AllApplicants(props) {
  const { appl } = props;
  return (
    <div className="col-xl-12">
      <div className="card">
        <div className="card-body">
          <div className="d-flex justify-content-between">
            <h5 className="card-title">All Applicants</h5>
          </div>
          <hr />
          <div className="row separate-row">
            <div className="col-sm-6 fw-bolder">
              <div className="job-icon pb-4">
                <div className="d-flex align-items-center mb-1">
                  <h2 className="mb-0 lh-1">{appl?.total_candidate ?? 0}</h2>
                  <i
                    className={`fa-solid ms-3 ${appl?.total_candidate_flag}`}
                  ></i>
                </div>
                <span className="fs-14 d-block mb-2">Total Applications</span>
              </div>
            </div>
            <div className="col-sm-6 fw-bolder">
              <div className="job-icon pb-4 pt-4 pt-sm-0 d-flex justify-content-between">
                <div>
                  <div className="d-flex align-items-center mb-1">
                    <h2 className="mb-0 lh-1">{appl?.today_candidate ?? 0}</h2>
                    <i
                      className={`fa-solid ms-3 ${appl?.today_candidate_flag}`}
                    ></i>
                  </div>
                  <span className="fs-14 d-block mb-2">Applications Today</span>
                </div>
              </div>
            </div>
            <div className="col-sm-6 fw-bolder">
              <div className="job-icon pt-4  d-flex justify-content-between">
                <div>
                  <div className="d-flex align-items-center mb-1">
                    <h2 className="mb-0 lh-1">{appl?.no_resume ?? 0}</h2>
                    <i className={`fa-solid ms-3 ${appl?.no_resume_flag}`}></i>
                  </div>
                  <span className="fs-14 d-block mb-2">No Resume</span>
                </div>
              </div>
            </div>
            <div
              className="col-sm-6 fw-bolder"
              style={{ "border-bottom": "1px solid #eee" }}
            >
              <div className="job-icon pt-4 ">
                <div className="d-flex align-items-center mb-1">
                  <h2 className="mb-0 lh-1">{appl?.lgbt_unverified ?? 0}</h2>
                  <i
                    className={`fa-solid ms-3 ${appl?.lgbt_unverified_flag}`}
                  ></i>
                </div>
                <span className="fs-14 d-block mb-2">Pending Verification</span>
              </div>
            </div>
            <div className="col-sm-6 fw-bolder">
              <div className="job-icon pt-4  d-flex justify-content-between">
                <div>
                  <div className="d-flex align-items-center mb-1">
                    <h2 className="mb-0 lh-1">{appl?.applicants_from ?? 0}</h2>
                    <i
                      className={`fa-solid ms-3 ${appl?.applicants_from_flag}`}
                    ></i>
                  </div>
                  <span className="fs-14 d-block mb-2">Locations</span>
                </div>
              </div>
            </div>
            <div className="col-sm-6 fw-bolder">
              <div className="job-icon pt-4  d-flex justify-content-between">
                <div>
                  <div className="d-flex align-items-center mb-1">
                    <h2 className="mb-0 lh-1">{appl?.onhold_candidate ?? 0}</h2>
                    <i
                      className={`fa-solid ms-3 ${appl?.onhold_candidate_flag}`}
                    ></i>
                  </div>
                  <span className="fs-14 d-block mb-2">Candidates on Hold/Offered</span>
                </div>
              </div>
            </div>

            <div
              className="col-sm-6"
              style={{ "border-bottom": "1px solid #eee" }}
            >
              <div className="job-icon pt-4 pb-sm-0 pb-4 pe-3 d-flex justify-content-between">
                <div>
                  <div className="d-flex align-items-center mb-1">
                    <h2 className="mb-0 lh-1">{appl?.active_candidate ?? 0}</h2>
                    <i
                      className={`fa-solid ms-3 ${appl?.active_candidate_flag}`}
                    ></i>
                  </div>
                  <span className="fs-14 d-block mb-2">
                    LGBT+ Active Candidates
                  </span>
                </div>
              </div>
            </div>

            <div className="col-sm-6">
              <div className="job-icon pt-4  d-flex justify-content-between">
                <div>
                  <div className="d-flex align-items-center mb-1">
                    <h2 className="mb-0 lh-1">{appl?.nonLgbt}</h2>
                    <i className={`fa-solid ms-3 ${appl?.nonLgbt_flag}`}></i>
                  </div>
                  <span className="fs-14 d-block mb-2">Non-LGBT+ Total Applications</span>
                </div>
              </div>
            </div>

            <div className="col-sm-6">
              <div className="job-icon pt-4  d-flex justify-content-between">
                <div>
                  <div className="d-flex align-items-center mb-1">
                    <h2 className="mb-0 lh-1">{appl?.nonLgbt_woman}</h2>
                    <i
                      className={`fa-solid ms-3 ${appl?.nonLgbt_woman_flag}`}
                    ></i>
                  </div>
                  <span className="fs-14 d-block mb-2">Women Total Candidates</span>
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="job-icon pt-4  d-flex justify-content-between">
                <div>
                  <div className="d-flex align-items-center mb-1">
                    <h2 className="mb-0 lh-1">{appl?.nonLgbt_man}</h2>
                    <i
                      className={`fa-solid ms-3 ${appl?.nonLgbt_man_flag}`}
                    ></i>
                  </div>
                  <span className="fs-14 d-block mb-2">Men Total Candidates</span>
                </div>
              </div>
            </div>

            <div className="col-sm-6">
              <div className="job-icon pt-4  d-flex justify-content-between">
                <div>
                  <div className="d-flex align-items-center mb-1">
                    <h2 className="mb-0 lh-1">{appl?.nonLgbt_active_woman}</h2>
                    <i
                      className={`fa-solid ms-3 ${appl?.nonLgbt_active_woman_flag}`}
                    ></i>
                  </div>
                  <span className="fs-14 d-block mb-2">Women Active Candidates</span>
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="job-icon pt-4  d-flex justify-content-between">
                <div>
                  <div className="d-flex align-items-center mb-1">
                    <h2 className="mb-0 lh-1">{appl?.nonLgbt_active_man}</h2>
                    <i
                      className={`fa-solid ms-3 ${appl?.nonLgbt_active_man_flag}`}
                    ></i>
                  </div>
                  <span className="fs-14 d-block mb-2">Men Active Candidates</span>
                </div>
              </div>
            </div>

            <div className="col-sm-6">
              <div className="job-icon pt-4  d-flex justify-content-between">
                <div>
                  <div className="d-flex align-items-center mb-1">
                    <h2 className="mb-0 lh-1">{appl?.delrequest_candidate}</h2>
                    <i
                      className={`fa-solid ms-3 ${appl?.delrequest_candidate_flag}`}
                    ></i>
                  </div>
                  <span className="fs-14 d-block mb-2">Delete Request (All)</span>
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="job-icon pt-4  d-flex justify-content-between">
                <div>
                  <div className="d-flex align-items-center mb-1">
                    <h2 className="mb-0 lh-1">{appl?.blacklisted_candidate}</h2>
                    <i
                      className={`fa-solid ms-3 ${appl?.blacklisted_candidate_flag}`}
                    ></i>
                  </div>
                  <span className="fs-14 d-block mb-2">
                    Blacklisted candidates (All)
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AllApplicants;
